import L from "leaflet";
import styled from "styled-components";
import { Marker, Popup, Tooltip } from "react-leaflet";
import { Link } from "react-router-dom";
import "./MarkerDetailBox.scss";

const Dot = styled.div`
  height: 16px;
  width: 16px;
  margin-right: 3px;
  background-color: ${(props) => (props.color ? props.color : "#bbb")};
  border-radius: 50%;
  display: inline-block;
`;

export default function FComponentMapMarker(props) {
  const getIconMaker = () => {
    let code = 0;
    if (props.sensors) {
      props.sensors.map((item) => {
        if (item.connection_status) {
          if (item.connection_status > code) code = item.connection_status;
        } else {
          if (item.parameters && item.parameters.length > 0) {
            item.parameters.map((item) => {
              if (item.connection_status > code) code = item.connection_status;
            });
          }
        }
      });
    }
    if (code) {
      if (code == 1) {
        return new L.Icon({
          iconUrl: "/icon/location-marker-green.svg",
          iconRetinaUrl: "/icon/location-marker-green.svg",
          iconSize: new L.Point(12, 12),
          className: "icon-map-marker",
        });
      } else if (code == 2) {
        return new L.Icon({
          iconUrl: "/icon/location-marker-yellow.svg",
          iconRetinaUrl: "/icon/location-marker-yellow.svg",
          iconSize: new L.Point(12, 12),
          className: "icon-map-marker",
        });
      } else if (code == 3) {
        return new L.Icon({
          iconUrl: "/icon/location-marker-red.svg",
          iconRetinaUrl: "/icon/location-marker-red.svg",
          iconSize: new L.Point(12, 12),
          className: "icon-map-marker",
        });
      } else {
        return new L.Icon({
          iconUrl: "/icon/location-marker-black.svg",
          iconRetinaUrl: "/icon/location-marker-black.svg",
          iconSize: new L.Point(12, 12),
          className: "icon-map-marker",
        });
      }
    } else {
      return new L.Icon({
        iconUrl: "/icon/location-marker-black.svg",
        iconRetinaUrl: "/icon/location-marker-black.svg",
        iconSize: new L.Point(12, 12),
        className: "icon-map-marker",
      });
    }
  };

  const getStationStatus = (code, msg) => {
    if (code == 1) {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Dot color={"#25EF13"} title={msg} />
          {msg}
        </div>
      );
    } else if (code == 2) {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Dot color={"#FFD02B"} title={msg} />
          {msg}
        </div>
      );
    } else if (code == 3) {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Dot color={"#800020"} title={msg} />
          {msg}
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Dot color={"#333333"} title={msg} />
          {msg}
        </div>
      );
    }
  };
  return (
    <Marker
      className="map-marker"
      position={
        props.position ? props.position : [props.gps_lat, props.gps_long]
      }
      icon={getIconMaker()}
      eventHandlers={{
        click: (e) => {
          e.target.openPopup();
        },
        // mouseover: (e) => {
        //   e.target.openPopup();
        // },
        // mouseout: (e) =>{
        //   setTimeout(() => {
        //     e.target.closePopup();
        //   }, 1);
        // }
      }}
    >
      {props.selected ? (
        <>
          {!props.noDesc ? (
            <Tooltip className="marker-popup-box">
              {/* <div className="row"><span>จังหวัด </span><span>{props.province_name}</span></div> */}
              {/* <div className="row"><span>ชื่อสถานี </span><span>{props.station_name}</span></div> */}
              <div className="row station">
                <span>สถานี </span>
                <span>{props.station_name}</span>
              </div>
              {props.sensors.map((item, index) => (
                <div key={index} className="row">
                  <div className="sensor-detail">
                    <div className="row">
                      <span>{item.name}</span>
                      <span>{item.parameter_disp_name}</span>
                    </div>
                    <div className="row">
                      <span>{item.data_datetime}</span>
                      <span>{item.proc_data}</span>
                    </div>
                    <div className="row">
                      {getStationStatus(
                        item.connection_status,
                        item.disp_connection
                      )}
                    </div>
                  </div>
                </div>
              ))}
              {/* <div className="btn"><Link to={'/stations/'+props.station_id}><button className="btn-primary">รายละเอียดเพิ่มเติม</button></Link></div> */}
            </Tooltip>
          ) : (
            ""
          )}
        </>
      ) : (
        <>
          {!props.noDesc ? (
            <Popup
              className="marker-popup-box"
              eventHandlers={{
                mouseover: (e) => {
                  alert(e);
                },
              }}
            >
              {/* <div className="row"><span>จังหวัด </span><span>{props.province_name}</span></div> */}
              {/* <div className="row"><span>ชื่อสถานี </span><span>{props.station_name}</span></div> */}
              <div className="row station">
                <span>สถานี </span>
                <span>{props.station_name}</span>
              </div>
              {props.sensors.map((item, index) => (
                <div key={index} className="row">
                  <div className="sensor-detail">
                    <div className="row">
                      <span>{item.name}</span>
                      <span>{item.parameter_disp_name}</span>
                    </div>
                    <div className="row">
                      <span>{item.data_datetime}</span>
                      <span>{item.proc_data}</span>
                    </div>
                    <div className="row">
                      {getStationStatus(
                        item.connection_status,
                        item.disp_connection
                      )}
                    </div>
                  </div>
                </div>
              ))}
              <div className="btn"><Link to={'/stations/'+props.station_id}><button className="btn-primary">รายละเอียดสถานะ</button></Link></div>
            </Popup>
          ) : (
            ""
          )}
        </>
      )}
    </Marker>
  );
}
